import React from 'react';
import SectionBackground from './SectionBackground/SectionBackground';
import InnnerContent from './InnerContent/InnerContent';

const Rewards = () => {
    return (
        <div className="max-width">

        <div className="css-9xd9rb  ">
        <SectionBackground />
        <InnnerContent />
      </div>
        </div>
    );
}

export default Rewards;
